@use "Styles/includes/variables";
@use "Styles/mixins" as mixins;

:host {
    box-sizing: border-box;
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: variables.$fontQuaternary;

    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    @include mixins.desktop-and-up {
        overflow-x: visible;
    }
}

:host > * {
    flex-shrink: 0;
}

*,
*::before,
*::after {
    box-sizing: inherit;
}
